import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { BarChart3, History, Activity, MessageSquare, Database } from "lucide-react";
import { AIAnalystDashboard } from "@/components/AIAnalystDashboard";
import { AIAnalystHistory } from "@/components/AIAnalystHistory";
import { AIAnalystExecutions } from "@/components/AIAnalystExecutions";
import { AIAnalystChat } from "@/components/AIAnalystChat";
import { AIDataHubTester } from "@/components/AIDataHubTester";

export default function AdminAIAnalyst() {
  return (
    <div className="container mx-auto py-6 space-y-6">
      <div className="flex items-center gap-3">
        <Database className="h-8 w-8 text-primary" />
        <div>
          <h1 className="text-3xl font-bold">AI Analyst Admin</h1>
          <p className="text-muted-foreground">
            Gerencie análises, relatórios e teste o AI Data Hub
          </p>
        </div>
      </div>

      <Tabs defaultValue="dashboard" className="w-full">
        <TabsList className="grid w-full grid-cols-5">
          <TabsTrigger value="dashboard" className="flex items-center gap-2">
            <BarChart3 className="h-4 w-4" />
            Dashboard
          </TabsTrigger>
          <TabsTrigger value="history" className="flex items-center gap-2">
            <History className="h-4 w-4" />
            History
          </TabsTrigger>
          <TabsTrigger value="executions" className="flex items-center gap-2">
            <Activity className="h-4 w-4" />
            Executions
          </TabsTrigger>
          <TabsTrigger value="chat" className="flex items-center gap-2">
            <MessageSquare className="h-4 w-4" />
            Chat
          </TabsTrigger>
          <TabsTrigger value="data-hub" className="flex items-center gap-2">
            <Database className="h-4 w-4" />
            Data Hub Test
          </TabsTrigger>
        </TabsList>

        <TabsContent value="dashboard" className="space-y-4">
          <AIAnalystDashboard />
        </TabsContent>

        <TabsContent value="history" className="space-y-4">
          <AIAnalystHistory />
        </TabsContent>

        <TabsContent value="executions" className="space-y-4">
          <AIAnalystExecutions />
        </TabsContent>

        <TabsContent value="chat" className="space-y-4">
          <AIAnalystChat />
        </TabsContent>

        <TabsContent value="data-hub" className="space-y-4">
          <AIDataHubTester />
        </TabsContent>
      </Tabs>
    </div>
  );
}
